import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconMoveToTopStyle0 = gravityIconIndividualCss;

const GravityIconMoveToTop = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '01240395546e738b7454f5ed3428def3835c6dd6', color: this.color, size: this.size }, h("svg", { key: '66c84f72ee62462f4e042e9a47ec029815344d09', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '9c2eceb6906a32d24d1639e6d85cf8ac09177373', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m10.79 8.21-5.28 5.28a.3.3 0 0 0 .21.51h10.56a.3.3 0 0 0 .21-.51l-5.28-5.28a.29.29 0 0 0-.42 0Z", fill: "currentColor" }), h("path", { key: '95990e38437518a37d024a4d5515354de3aaa94f', d: "M4.501 3a.5.5 0 0 0-.5.5v.495a.5.5 0 0 0 .5.5l13 .005A.5.5 0 0 0 18 4v-.5a.5.5 0 0 0-.5-.5h-13Z", fill: "currentColor" }))));
    }
};
GravityIconMoveToTop.style = GravityIconMoveToTopStyle0;

export { GravityIconMoveToTop as gravity_icon_move_to_top };

//# sourceMappingURL=gravity-icon-move-to-top.entry.js.map